import { render, staticRenderFns } from "./hint.vue?vue&type=template&id=4ad04a6a&scoped=true&"
var script = {}
import style0 from "./hint.vue?vue&type=style&index=0&id=4ad04a6a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad04a6a",
  null
  
)

export default component.exports